module.exports = __webpack_public_path__ + "static/media/bg_pointing_flower.041a51f6.png";